// Module
var code = "<div id=\"V-0D9609CA-1C65-47E2-9D4C-F1FC8246744C\"> <div data-b-component=\"dragdrop\" data-b-comp-dragable=\"true\"> <div data-b-content=\"{Binding decoratorComponent,ViewSelector:getCompactViewForFormBuilderStructureViewDecorators}\"> </div> </div> </div> ";
// Exports
export default code;